import React from 'react';
import { injectIntl, defineMessages } from 'react-intl';

import { Image } from 'semantic-ui-react';
import { Tooltip } from 'material-ui';

import * as common from 'libs/commonFunc';

import styles from './LeakCountInfo.css';
import classNames from 'classnames/bind';
const cx = classNames.bind(styles);

const LeakCountInfo = ({ edu, formatMessage, type, count, size, tooltip }) => {
  let icon = <Image src="/img/exam/info_all.png" />;
  if (type === 'file') {
    icon = <Image src="/img/exam/info_file.png" />;
  } else if (type === 'cert') {
    icon = <Image src="/img/exam/info_certificate.png" />;
  } else if (type === 'mail') {
    icon = <Image src="/img/exam/info_mail.png" />;
  } else if (type === 'edu-wait') {
    icon = <Image src="/img/edu/info_notyet.png" />;
  } else if (type === 'edu-ing') {
    icon = <Image src="/img/edu/info_proceed.png" />;
  } else if (type === 'edu-finish') {
    icon = <Image src="/img/edu/info_end.png" />;
  }

  let countText = count + defineMessages(formatMessage({ id: 'LeakCountInfo_1', defaultMessage: '개' }));
  if (edu) {
    countText = count + defineMessages(formatMessage({ id: 'LeakCountInfo_2', defaultMessage: '명' }));
  }

  if (tooltip) {
    return (
      <Tooltip title={tooltip} placement="top">
        <div className={cx('leak-count-area')}>
          {icon}
          {count ? (
            <div>
              <div className={cx('count-text')}>{countText}</div>
              {!edu ? <div className={cx('size-text')}>{'(' + common.fileSizeTrans(size).common + ')'}</div> : ''}
            </div>
          ) : (
            <div>-</div>
          )}
        </div>
      </Tooltip>
    );
  } else {
    return (
      <div className={cx('leak-count-area')}>
        {icon}
        {count ? (
          <div>
            <div className={cx('count-text')}>{countText}</div>
            {!edu ? <div className={cx('size-text')}>{'(' + common.fileSizeTrans(size).common + ')'}</div> : ''}
          </div>
        ) : (
          <div>-</div>
        )}
      </div>
    );
  }
};

export default injectIntl(LeakCountInfo);



// WEBPACK FOOTER //
// ./src/script/components/common/LeakCountInfo.js